"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenu = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledMenu = styled_components_1.default.div `
  border: 1px solid ${config_1.colors.pavement};
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(22, 21, 29, 0.1);
  padding: 0 16px;
  width: 100%;
`;
